import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignIsLoadedReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isLoaded = action.payload;
};

export default setDesignIsLoadedReducer;
